import {
    getTransactionStatus,
    getTransactionType
} from '../../../utils/helper';
import { Transactions } from './interfaces/Transactions';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import StatusIndicator from '../../../components/StatusIndicator';

const ViewTransactionsSummary = ({
    transactionDetails
}: {
    transactionDetails?: Transactions;
}) => {
    const { user } = useSelector((state: RootState) => state.user);

    return (
        <>
            <div className='hidden lg:flex items-center gap-8 mt-[32px] border-b border-gray300 pb-4'>
                <div className='flex gap-4 items-center'>
                    <StatusIndicator
                        status={getTransactionStatus(
                            transactionDetails?.status ?? 0
                        )}
                    />
                    <div className=''>
                        <p className='text-sm leading-[20px] text-ebony'>
                            Status
                        </p>
                        <p className='font-semibold text-ebony text-base'>
                            {getTransactionStatus(
                                transactionDetails?.status ?? 0
                            )}
                        </p>
                    </div>
                </div>

                <div className='pl-[0.9rem] mr-5'>
                    <p className='text-sm leading-[20px] text-ebony'>
                        Transaction ID
                    </p>
                    <p className='font-semibold text-ebony text-base'>
                        {transactionDetails?.transactionReference || '-'}
                    </p>
                </div>

                <div className='pl-[0.9rem] mr-5'>
                    <p className='text-sm leading-[20px] text-ebony'>
                        Transaction Type
                    </p>
                    <p className='font-semibold text-ebony text-base'>
                        {getTransactionType(
                            transactionDetails?.transactionType
                        ) || '-'}
                    </p>
                </div>

                <div className='pl-[0.9rem] mr-5'>
                    <p className='text-sm leading-[20px] text-ebony'>Date</p>
                    <p className='font-semibold text-ebony text-base'>
                        {dayjs(transactionDetails?.createdDate).format('ll')}
                    </p>
                </div>
            </div>

            <div className='block bg-white flex flex-col items-center pt-[24px] pb-[40px]  lg:hidden'>
                <StatusIndicator
                    status={getTransactionStatus(
                        transactionDetails?.status ?? 0
                    )}
                />

                <p className='mt-[16px] text-paleSky text-sm font-norma'>
                    {getTransactionType(transactionDetails?.transactionType)}
                </p>
                <p className='text-lg font-bold text-ebony'>
                    {`${transactionDetails?.fromCurrencyCode}${transactionDetails?.amountFrom?.toLocaleString()} - ${transactionDetails?.toCurrencyCode}${transactionDetails?.amountTo?.toLocaleString()}`}
                </p>
                <p className='mt-[8px] text-paleSky text-sm font-norma'>
                    {transactionDetails?.businessName}
                </p>
            </div>
        </>
    );
};

export default ViewTransactionsSummary;
